import type { TFunction } from 'i18next';
import type { FilterFieldOption } from '~/components/ui';
import {
  BUY_LIST_FILTER_FIELD,
  BUY_LIST_STATUSES,
  newBuyListFilterRowId,
  type BuyListFilterRow,
} from './buyListFilters';

type T = TFunction<'inventory'>;

export type BuyListFilterOptionSources = {
  locations: { label: string; value: string }[];
  transportVehicles: { label: string; value: string }[];
};

export function newBuyListFilterRow(): BuyListFilterRow {
  return {
    id: newBuyListFilterRowId(),
    field: BUY_LIST_FILTER_FIELD.platformProductIds,
    operator: 'in',
    value: [],
    connector: 'and',
  };
}

export function buyListStatusOptions(t: T): { label: string; value: string }[] {
  return BUY_LIST_STATUSES.map((status) => ({
    label: t(`inventory.buy_list.status.${status}`),
    value: status,
  }));
}

export function buyListFilterFields(
  t: T,
  sources: BuyListFilterOptionSources
): FilterFieldOption[] {
  const equalityOperatorOptions = [
    { label: t('inventory.buy_list.filter.operator_eq'), operator: 'eq' },
    { label: t('inventory.buy_list.filter.operator_neq'), operator: 'neq' },
  ];
  const collectionOperatorOptions = [
    { label: t('inventory.buy_list.filter.operator_in'), operator: 'in' },
    {
      label: t('inventory.buy_list.filter.operator_not_in'),
      operator: 'notIn',
    },
  ];

  return [
    {
      field: BUY_LIST_FILTER_FIELD.platformProductIds,
      label: t('inventory.buy_list.filter.field_product'),
      operatorOptions: collectionOperatorOptions,
      inputType: 'select',
    },
    {
      field: BUY_LIST_FILTER_FIELD.locationId,
      label: t('inventory.buy_list.filter.field_location'),
      operatorOptions: equalityOperatorOptions,
      inputType: 'select',
      selectOptions: sources.locations,
      withAllOption: true,
    },
    {
      field: BUY_LIST_FILTER_FIELD.transportVehicleId,
      label: t('inventory.buy_list.filter.field_vehicle'),
      operatorOptions: equalityOperatorOptions,
      inputType: 'select',
      selectOptions: sources.transportVehicles,
      withAllOption: true,
    },
    {
      field: BUY_LIST_FILTER_FIELD.status,
      label: t('inventory.buy_list.filter.field_status'),
      operatorOptions: collectionOperatorOptions,
      inputType: 'select',
      selectOptions: buyListStatusOptions(t),
    },
  ];
}
